import { useSelector } from 'react-redux';
import TrialNotifRow from './TrialNotifRow';
import UtilDate from '../../utils/UtilDate';
import { useTranslation } from 'react-i18next';
import UserActions from '../../actions/UserActions';

const MainLayoutResubscribeNotif = () => {
  const { t } = useTranslation();

  const statusClient = useSelector((state) => {
    return state.currentUser?.statusClient;
  });

  const paidUntilDateRedux = useSelector((state) => {
    return state?.currentUser?.paidUntilDate;
  });

  const paidUntilDate = paidUntilDateRedux
    ? UtilDate.getDate(paidUntilDateRedux)
    : UtilDate.getDateToday();

  const isExpired = UtilDate.isSameOrAfter(
    UtilDate.getDateToday(),
    paidUntilDate
  );

  if (statusClient === UserActions.STATUS.TRIAL) {
    return null;
  }

  if (isExpired) {
    return (
      <TrialNotifRow
        title={t('WORD_TRIAL_NOTIFICATION_DESCRIPTION')}
        btnLabel={t('WORD_PAY')}
        path={`/settings/package_change`}
      />
    );
  }
  return null;
};

export default MainLayoutResubscribeNotif;
